module.exports = __webpack_public_path__ + "ls.svg?fd0cc2e17bcb57d703a83d0079c316bd";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ls.svg
// module id = 1473
// module chunks = 0